import { Dispatch } from 'redux';
import { api } from '../config/axiosConfig';
import { activitiesConstants } from '../constants';
import { GetActivitiesResponse, ActivityFiltersState } from '../types';
import { Rep } from '../classes/Workout';
import { AxiosRequestConfig } from 'axios';
import { ChartDataPoint } from '../services/ChartDataManager';

export const getActivities = (id: string, query: any) => {
    const numId = parseInt(id);
    const request = () => (
        { type: activitiesConstants.ACTIVITIES_REQUEST }
    );

    const success = (data: GetActivitiesResponse) => (
        { type: activitiesConstants.ACTIVITIES_SUCCESS, data }
    );

    const failure = (data: GetActivitiesResponse) => (
        { type: activitiesConstants.ACTIVITIES_FAILURE, data }
    );

    const requestURL = `/v1/athletes/${numId}/activities`;

    let config: AxiosRequestConfig = { params: query };
    return (dispatch: Dispatch<any>) => {
        dispatch(request());
        api()
            .get(requestURL, config)
            .then((response) => {
                dispatch(success(response.data)); })
            .catch((error) => { dispatch(failure(error.response.data !=undefined ? error.response.data: "failure fetching athlete activities")); });
    };
};

export const updateActivitiesFilters = (filters: ActivityFiltersState) => (
    { type: activitiesConstants.UPDATE_FILTERS, data: filters }
);

export const setActivitiesPage = (page: number) => (
    { type: activitiesConstants.SET_PAGE, data: page }
);

export const archiveActivity = (id: number) => {
    const request = () => (
        { type: activitiesConstants.ARCHIVE_REQUEST }
    );

    const success = (data: number) => (
        { type: activitiesConstants.ARCHIVE_SUCCESS, data }
    );

    const failure = () => (
        { type: activitiesConstants.ARCHIVE_FAILURE }
    );

    const requestURL = `/v1/athlete/activities/${id}`;

    return (dispatch: Dispatch<any>) => {
        dispatch(request());
        api()
            .patch(requestURL, { isArchived: true })
            .then(() => { dispatch(success(id)); })
            .catch(() => { dispatch(failure()); });
    };
    
};

export const resetActivitiesState = () => (
    { type: activitiesConstants.ACTIVITIES_RESET_STATE }
);

export const uploadActivity = (activity:any) => {
        const success = (data: any) => {
            return{
                type: activitiesConstants.UPLOAD_SUCCESS,
                data: data
            }
        };
    
        const failure = (errors:any) => {
            return{ 
                type: activitiesConstants.UPLOAD_FAILURE,
                errors : errors
            }
        };
        const requestURL = '/v1/athlete/upload';
        return async (dispatch: any) => {
            console.log('uploadActivity: Sending activity to backend:', { 
                type: activity.type, 
                subtype: activity.subtype, 
                dataLength: activity.data?.length || 0, 
                intervalsCount: activity.intervals?.length || 0,
                userWeight: activity.userWeight 
            });
            
            return await api()
                .post(requestURL, activity)
                .then((response) => {   
                    console.log('uploadActivity: Backend response:', response);
                    console.log('uploadActivity: Response data:', response.data);
                    activity.id = response.data.id;                  
                    dispatch(success(activity));
                    console.log('uploadActivity: Successfully uploaded with ID:', response.data.id);
                    return response.data.id; // Return the uploaded ID
                })
                .catch((error) => { 
                    console.error('uploadActivity: Upload failed:', error);
                    console.error('uploadActivity: Error response:', error.response);
                    console.error('uploadActivity: Error data:', error.response?.data);
                    console.error('uploadActivity: Error status:', error.response?.status);
                    dispatch(failure(error)); 
                    throw error; // Re-throw to handle in component
                });        
            };
};

export const handleActivityStatus = (status: string)=>(
    { type: activitiesConstants.ACTIVITY_STATUS, data: status }
)
export const handleCalibrationStatus = (status: string)=>(
    { type: activitiesConstants.CALIBRATION_SATUS, data: status }
)
export const handleTimerStatus=(status:string)=>(
    { type: activitiesConstants.TIMER_STATUS, data: status }
)
export const handleCurrentRepUpdate=(newRep: Rep)=>(
    { type: activitiesConstants.CURRENT_REP, data: newRep }
)

// Timer actions
export const updateElapsedTime = (elapsedTime: number) => (
    { type: activitiesConstants.UPDATE_ELAPSED_TIME, data: elapsedTime }
)

export const resetElapsedTime = () => (
    { type: activitiesConstants.RESET_ELAPSED_TIME }
)

// Chart data actions
export const updateChartData = (data: ChartDataPoint[]) => (
    { type: activitiesConstants.UPDATE_CHART_DATA, data }
)

export const addChartDataPoint = (dataPoint: ChartDataPoint) => (
    { type: activitiesConstants.ADD_CHART_DATA_POINT, data: dataPoint }
)

export const addChartDataPoints = (dataPoints: ChartDataPoint[]) => (
    { type: activitiesConstants.ADD_CHART_DATA_POINTS, data: dataPoints }
)

export const clearChartData = () => (
    { type: activitiesConstants.CLEAR_CHART_DATA }
)

export const updateChartMaxValues = (maxValue: number, maxTime: number) => (
    { type: activitiesConstants.UPDATE_CHART_MAX_VALUES, data: { maxValue, maxTime } }
)

// Sensor data actions
export const addSensorDataPoint = (force: number, time: number) => (
    { type: activitiesConstants.ADD_SENSOR_DATA_POINT, data: [force, time] as [number, number] }
)

export const clearSensorData = () => (
    { type: activitiesConstants.CLEAR_SENSOR_DATA }
)

// Workout state management actions
export const initializeWorkout = (config: { totalReps: number; isBluetoothReady: boolean }) => (
    { type: activitiesConstants.INITIALIZE_WORKOUT, data: config }
)

export const startWorkout = () => (
    { type: activitiesConstants.START_WORKOUT }
)

export const pauseWorkout = () => (
    { type: activitiesConstants.PAUSE_WORKOUT }
)

export const resumeWorkout = () => (
    { type: activitiesConstants.RESUME_WORKOUT }
)

export const completeRep = (nextRep?: Rep) => (
    { type: activitiesConstants.COMPLETE_REP, data: nextRep }
)

export const completeWorkout = () => (
    { type: activitiesConstants.COMPLETE_WORKOUT }
)

export const resetWorkout = () => (
    { type: activitiesConstants.RESET_WORKOUT }
)

// Rep timer management actions
export const startRepTimer = () => (
    { type: activitiesConstants.START_REP_TIMER }
)

export const stopRepTimer = () => (
    { type: activitiesConstants.STOP_REP_TIMER }
)

export const resetRepTimer = () => (
    { type: activitiesConstants.RESET_REP_TIMER }
)

export const updateRepElapsedTime = (elapsedTime: number) => (
    { type: activitiesConstants.UPDATE_REP_ELAPSED_TIME, data: elapsedTime }
)

// Global timer management actions
export const startGlobalTimer = () => (
    { type: activitiesConstants.START_GLOBAL_TIMER }
)

export const stopGlobalTimer = () => (
    { type: activitiesConstants.STOP_GLOBAL_TIMER }
)

export const resetGlobalTimer = () => (
    { type: activitiesConstants.RESET_GLOBAL_TIMER }
)

export const updateGlobalElapsedTime = (elapsedTime: number) => (
    { type: activitiesConstants.UPDATE_GLOBAL_ELAPSED_TIME, data: elapsedTime }
)

// Current strength display action
export const updateCurrentStrength = (strength: number | 'MAX' | 'Out') => (
    { type: activitiesConstants.UPDATE_CURRENT_STRENGTH, data: strength }
)

// Workout-wide chart data actions
export const addWorkoutChartDataPoint = (dataPoint: ChartDataPoint) => (
    { type: activitiesConstants.ADD_WORKOUT_CHART_DATA_POINT, data: dataPoint }
)

export const clearWorkoutChartData = () => (
    { type: activitiesConstants.CLEAR_WORKOUT_CHART_DATA }
)
    
